import { useSelector } from "react-redux";
import { ISystemMessage } from '../../../actions';
import './index.css';

export default function SystemMessage(props: ISystemMessage) {

  const design = useSelector((state: any) => state?.design);
  const configuration = useSelector((state: any) => state?.configuration);

  const getSystemMessage = () => {

    switch (props.method) {
      case 'chat-request-accepted':
        return <>
          <p dir="ltr" className="ele-system-message-accepted text-secondaryText text-xs p-2 pl-2 pr-2 flex text-center align-middle items-center">
            <span className="font-bold ele-system-message-agent-name" style={{ color: configuration.chatMenu.liveChatInitiatePrimaryColor || '#226CF4' }}>{props.agentName || 'Agent'}</span> &nbsp; has joined the chat
          </p>
        </>
      case 'initiating-live-chat':
        return <>
          <div className="ele-system-message-initiate text-secondaryText text-xs p-2 pl-2 pr-2 flex flex-col text-center align-middle items-center">
            <div className="ele-system-message-title" style={{ color: configuration.chatMenu.liveChatInitiatePrimaryColor || '#226CF4' }}>{props.title}</div>
            <div className="ele-systyem-message-subtitle" style={{ color: configuration.chatMenu.liveChatInitiateSecondaryColor || '#333333' }}>{props.subTitle}</div>
          </div>
        </>
      case 'no-agent-found':
        return <>
          <div className="ele-system-message-no-agent text-secondaryText text-xs p-2 pl-2 pr-2 flex flex-col text-center align-middle items-center">
            <div className="ele-system-message-title" style={{ color: configuration.chatMenu.liveChatUnavailablePrimaryColor || '#b3261e' }}>{props.title}</div>
            <div className="ele-systyem-message-subtitle" style={{ color: configuration.chatMenu.liveChatInitiateSecondaryColor || '#333333' }}>{props.subTitle}</div>
          </div>
        </>
      default:
        return <>
          <div className="ele-system-message-default text-secondaryText text-xs p-2 pl-2 pr-2 flex flex-col text-center align-middle items-center">
            <div className="ele-system-message-title" style={{ color: design.themeColor || '#226CF4' }}>{props.title}</div>
            <div className="ele-systyem-message-subtitle">{props.subTitle}</div>
          </div>
        </>
    }
  }

  return (
    <div className='ele-system-message flex align-middle justify-around items-center w-full mt-2'>
      <div className="ele-system-message-line line"></div>
      {getSystemMessage()}
      <div className="ele-system-message-line line"></div>
    </div >
  )
}
